import usePostList from "../../hooks/usePostList";
import { resolveAssetUrl } from "../../services/apiConfig";
import { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart, faComment } from "@fortawesome/free-regular-svg-icons";
import { AuthContext } from "../../context/AuthContext";
import { faCartShopping, faHeart as faHeartSolid } from "@fortawesome/free-solid-svg-icons";
import styles from "../home/Home.module.css";
import { FollowModal as LikeModal } from "../../components/modal/FollowModal";
import { CommentModal } from "../../components/modal/CommentModal";
import Loader from "../../components/Loader/Loader";
import {
  getFollowingUserPosts,
  createComment,
} from "../../services/postService";
import { getFollowSuggestion } from "../../services/followService";
import { useFollow } from "../../hooks/useFollow";
import { useLike } from "../../hooks/useLike";
import { useComments } from "../../hooks/useComments";
import TextComposer from "../../components/textComposer/TextComposer";
import PostOptions from "../../components/postOptions/PostOptions";



function PostCard({ post, user_id, onChange }) {
  const [likes, setLike] = useState(post.likes.length || 0);
  const {
    comments,
    commentCount,
    isLoadingComments,
    commentsError,
    refreshComments,
    addComment,
  } = useComments(post);
  const [isLiked, setIsLiked] = useState(
    post.likes.some((like) => like.user_id === user_id)
  );
  const [isLike, setIsLike] = useState(false);
  const [isComment, setIsComment] = useState(false);
  const { animateHeart, updateLikes } = useLike();

  const handleLikeModal = (value) => {
    setIsLike(value);
  };

  const handleCommentModal = (value) => {
    setIsComment(value);
    if (value) refreshComments();
  };

  const submitComment = async (comment) => { try { const response = await createComment({ comment }, post.id, user_id); if (!response.success) throw new Error(response.message); addComment(response.comment); toast.success("Comentário publicado!"); } catch (error) { toast.error(error.message || "Algo deu errado! Tente novamente."); throw error; } };

  return (
    <div className={styles.feedContainer}>
      <div className={styles.profilePostedBy}>
        <div className={styles.profilePostedByImage}>
          <img
            src={
              post.user.profile_url
                ? resolveAssetUrl(post.user.profile_url)
                : resolveAssetUrl("images/profile_image/user.png")
            }
            alt=""
          />
        </div>
        <Link to={`/profile/${post.user.username}`}>
          <h3>{post.user.username}</h3>
        </Link>
        <PostOptions post={post} userId={user_id} onChange={onChange} />
      </div>
      <div
        className={styles.postImageContainer}
        onDoubleClick={() =>
          updateLikes(isLiked, setIsLiked, setLike, post.id, user_id)
        }
      >
        <img
          src={resolveAssetUrl(post.image_url)}
          alt={post.id}
          className={animateHeart ? styles.heartAnimation : ""}
        />
        <FontAwesomeIcon
          icon={faHeartSolid}
          className={`${styles.heartIcon} ${
            animateHeart ? styles.animate : ""
          }`}
        />
      </div>
      <div className={styles.likeAndCommentIcons}>
        <button type="button" className={styles.iconAction} aria-label={isLiked ? "Remover curtida" : "Curtir"} onClick={() => updateLikes(isLiked,setIsLiked,setLike,post.id,user_id).catch(() => toast.error("Não foi possível atualizar a curtida."))}>
          <FontAwesomeIcon icon={isLiked ? faHeartSolid : faHeart} className={isLiked ? styles.liked : ""} />
        </button>
        <div
          className={styles.likeCounts}
          onClick={() => handleLikeModal(true)}
        >
          {likes > 0 ? likes : ""}
        </div>
        <button type="button" className={styles.iconAction} aria-label="Ver comentários" onClick={() => handleCommentModal(true)}><FontAwesomeIcon icon={faComment} /></button>
        <div
          className={styles.likeCounts}
          onClick={() => handleCommentModal(true)}
        >
          {commentCount > 0 ? commentCount : ""}
        </div>
        <Link className={styles.iconAction} to={"/posts/" + post.id + "/comprar"} aria-label="Encontrar roupas similares para comprar"><FontAwesomeIcon icon={faCartShopping} /></Link>
      </div>
      <LikeModal
        isVisible={isLike}
        handleModal={handleLikeModal}
        users={post.likes}
        heading={"Likes"}
      />
      <CommentModal
        isVisible={isComment}
        handleModal={handleCommentModal}
        users={comments}
        heading={"Comentários"}
        isLoading={isLoadingComments}
        error={commentsError}
        composer={<TextComposer onSubmit={submitComment} />}
      />
      <div className={styles.captions}>{post.caption}</div>
      <div className={styles.comments}>
        <TextComposer onSubmit={submitComment} />
      </div>
    </div>
  );
}

function Home({ refreshVersion = 0 }) {
  const { user } = useContext(AuthContext);
  const { followState, setFollowState, handleFollow } = useFollow();
  const { posts, isLoading, setPosts } = usePostList(getFollowingUserPosts, refreshVersion);
  const [isSuggest, setIsSuggest] = useState(false);
  const [suggestFollow, setSuggestFollow] = useState([]);

  const handleFollowSuggestion = (value) => {
    setIsSuggest(value);
  };



  useEffect(() => {
    const fetchFollowSuggestion = async () => {
      try {
        const response = await getFollowSuggestion(user.id);
        setSuggestFollow(response.suggestionFollow);

        const initialFollowState = {};
        response.suggestionFollow.forEach((user) => {
          initialFollowState[user.id] = false;
        });
        setFollowState(initialFollowState);
      } catch (error) {
        console.error("Error fetching follow suggestion:", error);
      }
    };
    fetchFollowSuggestion();
  }, [user, setFollowState]);

  return (
    user &&
    (isLoading ? (
      <Loader />
    ) : (
      <div className={styles.home}>
        <div className={styles.feed}>
          {posts.length > 0 ? (
            posts.map((post) => (
              <PostCard key={post.id} post={post} user_id={user.id} onChange={updated => setPosts(current => updated ? current.map(item => item.id === post.id ? updated : item) : current.filter(item => item.id !== post.id))} />
            ))
          ) : (
            <p className={styles.noPost}>Seu feed ainda está vazio. Publique seu primeiro look ou siga outras pessoas.</p>
          )}
        </div>
        <div className={styles.sugesstionToFollow}>
          <div className={styles.suggestionTextLink}>
            <p>Sugestões</p>
            <button onClick={() => handleFollowSuggestion(true)}>
              Ver todas
            </button>
            <LikeModal
              isVisible={isSuggest}
              handleModal={handleFollowSuggestion}
              users={suggestFollow}
              heading={"Suggestion to follow"}
            />
          </div>
          {suggestFollow && suggestFollow.length > 0 ? (
            suggestFollow.map((follow) => {
              const isFollowing = followState[follow.id] || false;
              return (
                <div className={styles.suggestedAccount} key={follow.id}>
                  <div className={styles.accountDetails}>
                    <div className={styles.accountImage}>
                      <img
                        src={
                          follow.profile_url
                            ? resolveAssetUrl(follow.profile_url)
                            : resolveAssetUrl("images/profile_image/user.png")
                        }
                        alt={follow.username}
                      />
                    </div>
                    <Link to={`/profile/${follow.username}`}>
                      {" "}
                      <p>{follow.username}</p>
                    </Link>
                  </div>
                  <button
                    onClick={() => handleFollow(follow.id)}
                    className={isFollowing ? styles.unfollow : ""}
                  >
                    {isFollowing ? "Deixar de seguir" : "Seguir"}
                  </button>{" "}
                </div>
              );
            })
          ) : (
            <p>Nenhuma sugestão disponível</p>
          )}
        </div>
      </div>
    ))
  );
}

export default Home;
